export default {
  TagManagement: {
    tagsdata: [],
    filter:{
      name:''
    }
  },
}